const ErrorsPanel = ({ errors }) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="container m-auto w-full p-2">
      <div className="container w-full text-xl">
        Warning, some assets failed to load
      </div>
      <ul>
        {errors.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorsPanel;
